import {action, computed, makeObservable, observable} from "mobx"
import {makePersistable} from "mobx-persist-store"

export enum SpeedUnit {
	KmPerHour = "kilometers.per.hour",
	MPerSec = "meters.per.second",
	Knots = "knots"
}

export enum DeviceType {
	Mobile = "mobile",
	Tablet = "tablet",
	Desktop = "desktop"
}

export interface ISettings {
	units: {
		speed: SpeedUnit
	}
	show: {
		speed: boolean
		coordinates: boolean
	}
	togglePanel: (panelName: keyof ISettings["show"]) => void
	readonly deviceType: DeviceType
  readonly isMobile: boolean
  readonly isDesktop: boolean
  setMenuTop: (menuTop: number) => void
  menuTop: number // высота меню от нижней точки экрана
}

export class Settings implements ISettings {
	units: {
		speed: SpeedUnit
	}
	show: {
		speed: boolean
		coordinates: boolean
	}
	deviceType:DeviceType = DeviceType.Mobile
  menuTop: number = 0

	constructor() {
		this.units = {
			speed: SpeedUnit.KmPerHour
		}
		this.show = {
			speed: false,
			coordinates: false
		}
		this.deviceType = this.detectDevice()

		makeObservable(this, {
			units: observable,
			show: observable,
      isMobile: computed,
      isDesktop: computed,
      togglePanel: action
		})

		makePersistable(this, {
			name: 'settings',
			properties: ["units", "show"],
			storage: window.localStorage
		})
	}

	detectDevice (): DeviceType {
		const ua = navigator.userAgent.toLowerCase()
		if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua))
      return DeviceType.Tablet
    else if(/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(ua))
      return DeviceType.Mobile
    else return DeviceType.Desktop
	}

	togglePanel (panelName: keyof ISettings["show"]) {
		if (this.show.hasOwnProperty(panelName)) {
			this.show[panelName] = !this.show[panelName]
		}
	}

  setMenuTop(menuTop: number) {
    this.menuTop = menuTop
  }

  get isMobile() {
    return this.deviceType === DeviceType.Mobile
  }

  get isDesktop() {
    return this.deviceType === DeviceType.Desktop
  }
}
